import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { DepartmentCreateModel, DepartmentModel } from 'Pages/departments'
import { FileWithPreview } from 'LibNeo'

export type DepartmentState = {
	reload: boolean
	department: ResponseCatalog<DepartmentModel>
	editDepartment: DepartmentModel | null
	requestParams: RequestParams
	isLoading: boolean
}

export const departmentInitialState: DepartmentState = {
	reload: false,
	department: new ResponseCatalog<DepartmentModel>(),
	editDepartment: null,
	requestParams: new RequestParams(),
	isLoading: false,
}

export namespace DepartmentNS {
	export type GetDepartmentList = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Function
	}>
	export type GetOne = PayloadAction<string>
	export type SetOne = PayloadAction<DepartmentModel>
	export type UpdateOne = PayloadAction<{
		id: string
		data: DepartmentCreateModel
		callback?: Function
	}>
	export type CreateOne = PayloadAction<{
		data: DepartmentCreateModel
		callback?: Function
	}>
	export type SetDepartmentList = PayloadAction<ResponseCatalog<DepartmentModel>>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type SetIsLoading = PayloadAction<boolean>
	export type createMass = PayloadAction<FileWithPreview>
}

export const departmentSlice = createSlice({
	name: 'department',
	initialState: departmentInitialState,
	reducers: {
		getDepartmentList: (state, action: DepartmentNS.GetDepartmentList) => {},
		setDepartmentList: (state, action: DepartmentNS.SetDepartmentList) => {
			state.reload = state?.reload ?? false
			state.department = action.payload
		},
		setRequestParams: (state, action: DepartmentNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.department = new ResponseCatalog<DepartmentModel>()
			state.requestParams = new RequestParams()
		},
		setIsLoading: (state, action: DepartmentNS.SetIsLoading) => {
			state.isLoading = action.payload
		},
		getOne: (state, action: DepartmentNS.GetOne) => {},
		setOne: (state, action: DepartmentNS.SetOne) => {
			state.editDepartment = action.payload
		},
		updateOne: (state, action: DepartmentNS.UpdateOne) => {},
		createOne: (state, action: DepartmentNS.CreateOne) => {},
		createMass: (state, action: DepartmentNS.createMass) => {},
	},
})
